import { useState } from 'react'
import './Donate1Hero.css'
import { PaystackDonateModal } from './PaystackDonateModal'

export function Donate1Hero(): JSX.Element {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <div className="Donate1Hero">
      <div className="Donate1Hero-Overlay">
        <div className="Donate1Hero-TextZone">
          <h1 className="Donate1Hero-Headline">
            Over 20,000 pangolins are killed
            <br /> annually in Southeast Nigeria.
            <br />
            <br />
            Help make a difference.
            <br />
          </h1>
        </div>
        <button type="button" className="Donate1Hero-DonateButton Donate1Hero-DonateButton-Placeholder" disabled>
          Coming Soon
        </button>
      </div>
      <img
        className="Donate1Hero-Image"
        src="/images/donations/Credit_Alex Moore (4) copy 2.jpg"
        alt="Pangolin conservation work by Pangolino"
      />
      <p className="Donate1Hero-Credit">Photo by Joel Porter</p>
      <PaystackDonateModal visible={modalVisible} onClose={() => setModalVisible(false)} />
    </div>
  )
}
